






















































































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Collapse, CollapseItem, Switch, Cell, CellGroup, Checkbox, CheckboxGroup, Popup, Picker, Dialog } from "vant";
import axios from "axios";
import FlightPolicyService from "@/service/flightPolicyService";
import SystemService from "@/service/UserService";
import * as _ from "lodash";
import { FlightProductEntity, FlightGoodsEntity, FlightPolicyEntity } from "../../../model/FlightPolicy";
import { DurationTime } from "@/utils/utils.ts";
import { RoleInfoEntity } from "../../../model/system";
import orderFrame from "../orderFrame.vue";
import { ServiceType } from "@/model/Base";

@Component({
  name: "flightOrder",
  components: {
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    orderFrame,
  },
  filters: {
    DurationTime,
  },
})
export default class extends Vue {
  Products: FlightProductEntity[] = [];
  Goods: FlightGoodsEntity = {};
  activeNames: string[] = [];

  isShowFlightTips = false;
  isShowBaggageTips = false;
  policys: FlightPolicyEntity[] = [];

  get ServiceType() {
    return ServiceType.FlightService;
  }
  get ProductId() {
    return this.$route.query.ProductId;
  }
  get orderInfo() {
    return this.$route.query;
  }
  get applyArea() {
    return this.$route.query.ApplyArea;
  }

  // mountedFlag = false;
  mounted() {
    this.getInfoData();

    // this.mountedFlag = true;
  }

  getInsurancePrice(model: any) {
    let totalPrice = 0;
    for (let i = 0; i < model.Extras.length; i++) {
      let Extra = model.Extras[i];
      if (Extra.ServiceType == ServiceType.InsuranceService && model.insurances) {
        model.insurances.forEach((o: any) => {
          o.Goods.forEach((i: any) => {
            const minPrice = i.Prices.find((p: any) => p.SourceID == Extra.ThrowID);
            if (minPrice) totalPrice += minPrice.SalesPrice * (Extra.ProductIds?.length || 1);
          });
        });
      }
    }
    return totalPrice;
  }
  //methods
  handleExtra(Extras: any[]) {
    const Extra = _.find(Extras, item => {
      return item.ExtraCode == "flight.StopProduceName";
    });
    if (Extra) {
      return this.$root.$t("mall_flight_flightlist_jingting");
    }
    return this.$root.$t("mall_flight_flightorder_zhifei");
  }
  extra(extras: any[], extraCode: string) {
    const Extra = _.find(extras, item => item.ExtraCode == extraCode);
    if (Extra && Extra.ExtraData) {
      return Extra.ExtraData;
    }
    return null;
  }
  getInfoData() {
    const query = this.$route.query;
    const data = {
      ProductID: query.ProductId,
      VoyageType: query.VoyageType,
      BookingType: query.BookingType,
      ApplyArea: query.ApplyArea,
    };
    FlightPolicyService.getPriceVerify(data).then(priceRes => {
      if (priceRes.isSucc) {
        FlightPolicyService.getProductInfo(data).then(res => {
            if (res.isSucc && res.result) {
              let policys = res.result as any;
              this.policys = policys;
              this.Products = res.result[0].Products!;
              this.Goods = res.result[0].Goods![0];
            
              let policy: any = policys[policys.length - 1];
              this.activeNames.push(policy.PolicyID);
              // this.$emit("loadPolicys", policys);
            } else {
              Dialog.alert({
                message: `${res.message}`,
              }).then(() => {
                this.$router.push("/mall/flight");
              });
            }
        });
      }
    })
  }

  totalPrices(type: number[]): number {
    let sumPrice = 0;
    if (!this.policys) {
      return sumPrice;
    }
    for (let i = 0; i < this.policys.length; i++) {
      const policy = this.policys[i];
      const goods = (policy as any).Goods[0] as FlightGoodsEntity;
      for (let p = 0; p < goods.Prices!.length; p++) {
        const price = goods.Prices![p];
        // if (price.GroupCode == label) {
        //   sumPrice += price.MarketPrice;
        // }
        if (type.includes(price.PriceType)) {
          sumPrice += price.SalesPrice;
        }
      }
    }
    return sumPrice;
  }
  calculateTimeDifference(startTime: string | Date, endTime: string | Date) {
    const startDate: number = (new Date(startTime) as unknown) as number;
    const endDate: number = (new Date(endTime) as unknown) as number;
    // 计算时间差，单位为秒
    let diffInSeconds = (endDate - startDate) / 1000;
    // 计算天数
    const days = Math.floor(diffInSeconds / (24 * 3600));
    // 剩余的小时数
    const hours = Math.floor((diffInSeconds % (24 * 3600)) / 3600);
    // 剩余的分钟数
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    // 构建返回结果
    let result = "";
    if (days > 0) result += `${days}d`;
    if (hours > 0) result += `${hours < 10 ? "0" + hours : hours}h`;
    if (minutes > 0) result += `${minutes < 10 ? "0" + minutes : minutes}m`;
    return result;
  }
  AirplaneModel(list: any) {
    let AirplaneModel = "";
    let result = _.find(list.Extras, o => {
      return o.ExtraCode == "flight.AirplaneModel";
    });
    if (result) {
      AirplaneModel = result.ExtraData;
    }
    return AirplaneModel;
  }
}
